import React, { useEffect, useState } from "react";
import * as cmFun from "common/ulti/commonFunction";
import * as ccFun from "common/ulti/cookieFunction";
import * as generalServices from "../../controller/services/generalServices";
import * as meServices from "../../controller/services/meServices";
import { LoadingComponent } from "interface/components";
import { HOME_PAGE } from "../../config";
import { fetchGeneral, fetchProfile } from "../../controller/redux/app-reducer";
import { toast } from "react-toastify";
import { fetchLoginSuccess } from "../../controller/redux/login-reducers";
import { AUTHORIZATION_COOKIE, __DEV__ } from "common/ulti/constants";
import { BrowserRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createBrowserHistory } from "history";
import WebLayout from "./layouts/Web/index";
import AuthLayout from "./layouts/Auth/index";
import { FloatButton } from "antd";
import ChangePasswordModal from "interface/components/passwordnotify/index";
import moment from "moment";
import VerificationPhoneModal from "interface/components/verificationphonenotify/index";

const history = createBrowserHistory();

export default function NavigationRouter() {
  const dispatch = useDispatch();

  const LoginRes = useSelector((state) => state.LoginRes);
  const ToastNotify = useSelector((state) => state.ToastNotify);
  const Profile = useSelector((state) => state.Profile);

  const [verified, setVerified] = useState(false);
  const [allDone, setAllDone] = useState(false);

  const [needToChangePassword, setNeedToChangePassword] = useState(false);
  const [needToVerificationPhone, setNeedToVerificationPhone] = useState(false);

  // useEffect(() => {
  //   console.log("useEffect", LoginRes);
  // }, [LoginRes]);

  useEffect(() => {
    async function fetchData() {
      if (cmFun.isEmpty(LoginRes) && ccFun.getCookie(AUTHORIZATION_COOKIE)) {
        dispatch(
          fetchLoginSuccess(
            JSON.parse(cmFun.decode(ccFun.getCookie(AUTHORIZATION_COOKIE))),
          ),
        );
      } else {
        setAllDone(true);
      }
    }
    fetchData();
  }, [dispatch, LoginRes]);

  useEffect(() => {
    async function checkLoginAndInit() {
      if (!cmFun.isEmpty(LoginRes) && ccFun.checkCookie(LoginRes)) {
        setVerified(true);
        await _getUserProfile();
        await _initGeneral();
      } else {
        setVerified(false);
      }
      setAllDone(true);
    }
    checkLoginAndInit();
  }, [LoginRes]);

  useEffect(() => {
    if (!cmFun.isEmpty(ToastNotify)) {
      const notifyType = ToastNotify.type || "error";
      const notifyData = typeof ToastNotify.data === "string"
        ? ToastNotify.data
        : (ToastNotify.data?.message || "Có lỗi xảy ra, vui lòng thử lại sau!");
      if (typeof toast[notifyType] === "function") {
        toast[notifyType](notifyData);
      }
    }
  }, [ToastNotify]);

  useEffect(() => {
    if (!cmFun.isEmpty(LoginRes)) {
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");
      if (
        redirectPath &&
        redirectPath !== "/" &&
        redirectPath !== "/home" &&
        redirectPath !== "/oauth" &&
        redirectPath !== "/register" &&
        redirectPath !== "/about" &&
        !redirectPath.includes("/sso/vneid/signin") &&
        !redirectPath.includes("/vneid-login")
      ) {
        sessionStorage.removeItem("redirectAfterLogin");
        window.location.replace(HOME_PAGE + redirectPath); // dùng navigate nếu không muốn reload toàn bộ
      }
    }
  }, [LoginRes]);

  useEffect(() => {
    if (
      LoginRes?.user?.loaitaikhoan !== "VNEID" &&
      !cmFun.isEmpty(LoginRes) &&
      // !cmFun.isEmpty(Profile) &&
      ccFun.checkCookie(LoginRes) &&
      (!Profile?.changePassword?.changed ||
        isWithin90Days(Profile?.changePassword?.time || 0))
    ) {
      setNeedToChangePassword(true);
    }
  }, [Profile]);

  useEffect(() => {
    if (
      LoginRes?.user?.loaitaikhoan === "VNEID" &&
      !cmFun.isEmpty(LoginRes) &&
      // !cmFun.isEmpty(Profile) &&
      ccFun.checkCookie(LoginRes) &&
      !Profile?.SoDienThoaiDaXacThuc
    ) {
      setNeedToVerificationPhone(true);
    }
  }, [Profile]);

  const isWithin90Days = (timestamp) => {
    // Chuyển timestamp sang đối tượng moment
    const inputDate = moment(timestamp);

    // Ngày hiện tại
    const now = moment();

    // Tính số ngày chênh lệch
    const diffDays = now.diff(inputDate, "days");

    // Nếu nhỏ hơn hoặc bằng 90 ngày => true
    return diffDays >= 90;
  };

  const _initGeneral = async () => {
    let axiosRes = await generalServices.getMenu();
    let axiosResConfigDev = await generalServices.getConfigDev();
    let menu = axiosRes && axiosRes._embedded ? axiosRes._embedded : [];
    let configDev =
      axiosResConfigDev && axiosResConfigDev._embedded
        ? axiosResConfigDev._embedded
        : [];
    let showUC = configDev.find((e) => e.key === "UC_DEV")?.value ?? false;
    dispatch(fetchGeneral({ Menu: menu, ShowUC: showUC, isLoaded: true }));
  };

  const _getUserProfile = async () => {
    let axiosRes = await meServices.getInfoByEmail(
      LoginRes?.user?.email || LoginRes?.user?.sub || LoginRes?.user?.identity,
    );
    dispatch(fetchProfile(axiosRes?.data));
  };

  if (!allDone) {
    return <LoadingComponent />;
  }
  return (
    <BrowserRouter basename={HOME_PAGE} history={history}>
      {verified ? <WebLayout /> : <AuthLayout />}
      <FloatButton.BackTop />
      <ChangePasswordModal isOpen={needToChangePassword} />
      <VerificationPhoneModal isOpen={needToVerificationPhone} />
    </BrowserRouter>
  );
}
